export const brand = {
  name: 'Protocolo Octubre Rosa™',
  short: 'PROTOCOLO OCTUBRE ROSA',
  tag: 'Solución profesional para salud femenina',
}

export const checkoutUrl = 'https://octubre-rosa.impultienda.ar'

export const mockups = {
  kit: 'https://cdn.magicpatterns.com/uploads/u2brELFVHDsdJQ472bgBGi/mockup.webp',
  cards: 'https://cdn.magicpatterns.com/uploads/a3yycwDGTeTYQYMYKLZEVW/1.webp',
  journal: 'https://cdn.magicpatterns.com/uploads/8vhgbCW9TLhhD7o1qzu7Au/prod2.webp',
  guide: 'https://cdn.magicpatterns.com/uploads/nxKzaf6GPaUWKdFWbS4QVH/prod3.webp',
  gifts: 'https://cdn.magicpatterns.com/uploads/6CTBDGSngVnKvgywKhg3eS/prod4.png',
}

export const heroFacts: string[] = [
  'Acceso inmediato',
  '140+ páginas',
  '50 tarjetas',
  'Kit 4 en 1',
]

export interface Quote {
  initials: string
  quote: string
  author: string
  role: string
}

export const quickQuotes: Quote[] = [
  {
    initials: 'MG',
    quote:
      'Quería hacer algo por Octubre Rosa, pero no sabía por dónde empezar. Lo compré un lunes y el jueves ya tenía mi jornada lista. Vi a mujeres que llegaron cerradas abrirse por completo.',
    author: 'Lic. María González',
    role: 'Psicóloga',
  },
  {
    initials: 'CR',
    quote:
      'Como docente, me ahorró muchísimo tiempo de diseño. Todo viene listo para usar: tarjetas, diario y guía. El Manual de Contención me dio más seguridad para acompañar cada momento.',
    author: 'Prof. Carlos Ruiz',
    role: 'Docente',
  },
  {
    initials: 'PG',
    quote:
      'En recursos humanos nos sirvió muchísimo. Logramos un diálogo real sobre prevención y autocuidado sin sonar corporativos, y el equipo se sintió visto y cuidado.',
    author: 'Lic. Patricia Gómez',
    role: 'Directora de Talento',
  },
  {
    initials: 'GR',
    quote:
      'Tengo consultorio hace quince años y nunca había usado un material así. Una paciente se llevó una tarjeta y al día siguiente me escribió: “Cuando la vi, me sentí menos sola”.',
    author: 'Lic. Gabriela Rodríguez',
    role: 'Psicóloga',
  },
]

export const deepQuotes: Quote[] = [
  {
    initials: 'AL',
    quote:
      'Lo imprimí en la tarde y lo usé al día siguiente. Mis estudiantes no recibieron un papel más: recibieron una herramienta con propósito. La guía de dinámicas fue clave para hacerlo sin improvisar.',
    author: 'Prof. Alejandra López',
    role: 'Docente',
  },
  {
    initials: 'PG',
    quote:
      'Hicimos las dinámicas con el equipo y se generó un diálogo real sobre prevención y autocuidado. Colegas que casi nunca hablan en reuniones participaron, y desde otras áreas me pidieron el material.',
    author: 'Lic. Patricia Gómez',
    role: 'Directora de Talento',
  },
  {
    initials: 'JP',
    quote:
      'Usé el protocolo en un taller con veinte adolescentes y vi a chicos que casi nunca hablan compartir cosas que no habían contado antes. El Manual de Contención me dio seguridad para estar presente.',
    author: 'Lic. Juan Pérez',
    role: 'Psicopedagogo',
  },
]

export interface ProductImage {
  src: string
  alt: string
}

export interface Product {
  eyebrow: string
  title: string
  lead: string
  body: string
  points?: string[]
  kicker: string
  images: ProductImage[]
}

export const products: Product[] = [
  {
    eyebrow: 'Producto 1',
    title: '50 Tarjetas Reflexivas',
    lead: '50 tarjetas con mensajes que invitan a detenerse, reflexionar y recordar la importancia del autocuidado.',
    body: 'Puedes utilizarlas en dinámicas grupales, sesiones individuales o entregarlas como un pequeño regalo. Vienen listas para imprimir en alta resolución.',
    kicker: 'El catalizador que abre puertas cerradas.',
    images: [
      {
        src: mockups.cards,
        alt: 'Tablet sobre un escritorio mostrando el PDF de las tarjetas reflexivas con nueve preguntas para abrir conversación',
      },
    ],
  },
  {
    eyebrow: 'Producto 2',
    title: 'Diario del Participante — 20 páginas',
    lead: 'Una herramienta para que la experiencia continúe después del encuentro.',
    body: 'Incluye reflexiones guiadas, espacios de escritura, seguimiento de prevención, afirmaciones, rituales de autocuidado, carta al cuerpo y acciones concretas. Un material pensado para acompañar a cada participante durante octubre.',
    kicker: 'No es para leer. Es para vivir.',
    images: [
      {
        src: mockups.journal,
        alt: 'Mi Diario Octubre Rosa: portada y páginas interiores con reflexiones guiadas y espacios de escritura sobre un escritorio de madera',
      },
    ],
  },
  {
    eyebrow: 'Producto 3',
    title: 'Guía de Facilitación Octubre Rosa — 50 páginas',
    lead: 'Para que puedas facilitar tu Jornada Rosa sin tener que improvisar.',
    body: '',
    points: [
      '3 formatos de dinámicas de 15, 60 y 90 minutos',
      'Frases de apertura y acompañamiento',
      'Manejo de momentos emocionales',
      'Cuándo recomendar ayuda profesional',
      'Checklist de preparación',
      'Adaptaciones según el grupo',
    ],
    kicker: 'Es como tener una mentora profesional dentro del producto.',
    images: [
      {
        src: mockups.guide,
        alt: 'Guía de Facilitación Octubre Rosa: portada y páginas interiores con los principios de facilitación y los formatos de dinámicas',
      },
    ],
  },
  {
    eyebrow: 'Producto 4',
    title: '10 Tarjetas de Regalo + 5 Pegatinas + Cajita para armar',
    lead: 'Pequeños recuerdos con mensajes de autocuidado y empoderamiento para entregar al finalizar la experiencia.',
    body: 'También incluye una cajita imprimible para armar, ideal para guardar y presentar las tarjetas y pegatinas de una forma más linda y profesional. Un detalle simple que prolonga el mensaje mucho más allá del encuentro.',
    kicker: 'Un sticker en el espejo cada mañana recuerda: “Yo me cuido”.',
    images: [
      {
        src: mockups.gifts,
        alt: 'Caja “Toma aquí una dosis de cariño” con tarjetas de regalo, pegatinas circulares, mariposa recortable y cartel de Octubre Rosa',
      },
    ],
  },
]

export const deliverables: string[] = [
  '50 tarjetas reflexivas listas para imprimir',
  'Diario del Participante de 20 páginas',
  'Guía de Facilitación Octubre Rosa de 50 páginas',
  '10 Tarjetas de Regalo + 5 Pegatinas',
  'Cajita imprimible para armar y presentar los recuerdos',
  'PDFs en alta resolución (300 DPI)',
  'Acceso inmediato por email',
  'Uso ilimitado de por vida',
  'Soporte por email',
]

export interface Bonus {
  tag: string
  title: string
  subtitle: string
  lead: string
  promise: string
  includes: string[]
  value: string
}

export const bonuses: Bonus[] = [
  {
    tag: 'Bono #1',
    title: 'Manual de Contención Emocional para Octubre Rosa',
    subtitle: '“Qué decir en cada momento para no quedarte en blanco”',
    lead: 'Aprende cómo acompañar cuando alguien se emociona o comparte una experiencia difícil.',
    promise: 'Este bono te quita el miedo. Ganas seguridad.',
    includes: [
      'Las 5 reglas de oro',
      'Frases seguras para cada situación',
      'Qué evitar decir',
      'Cómo validar sin invadir',
      'Señales de alerta',
      'Protocolo de emergencia',
    ],
    value: '$4.90 USD',
  },
  {
    tag: 'Bono #2',
    title: 'Octubre Rosa sin Mitos',
    subtitle: '“Hablar de prevención con claridad y responsabilidad”',
    lead: 'Una guía práctica para comunicar sobre Octubre Rosa sin caer en información confusa o mensajes que generen miedo.',
    promise: 'Este bono te da autoridad. Hablas con confianza y las participantes se van con claridad.',
    includes: [
      'Qué significa Octubre Rosa',
      '5 mitos y realidades',
      'Cómo hablar sin asustar',
      'Preguntas útiles',
      'Checklist de prevención',
      'Lenguaje que empodera',
    ],
    value: '$3.90 USD',
  },
  {
    tag: 'Bono #3',
    title: 'Planificador Express: Jornada Rosa en 48 horas',
    subtitle: '“Organiza tu jornada completa en solo 2 días”',
    lead: 'Una ruta paso a paso para preparar tu Jornada Rosa aunque empieces desde cero.',
    promise: 'Este bono mata la paralización. Te da la ruta exacta.',
    includes: [
      'Método de 48 horas (4 fases)',
      'Agendas de 30 / 60 / 90 minutos',
      'Checklist de materiales',
      'Preparación del espacio',
      'Apertura y cierre',
      'Adaptaciones por contexto',
    ],
    value: '$3.90 USD',
  },
]

export const bonusTotal = '$12.70 USD'

export const offer = {
  listPrice: '$24.90',
  price: '$13.90',
  currency: 'USD',
  subtitle: 'Oferta de Lanzamiento | Acceso de por vida',
  detail:
    'Recibes 140+ páginas de material profesional + 3 bonos exclusivos ($12.70 USD en valor) + soporte por email.',
  cta: 'Quiero acceder al Protocolo Octubre Rosa',
}

export const trustItems = [
  { icon: 'lock', label: 'Pago 100% seguro' },
  { icon: 'check', label: 'Acceso inmediato' },
  { icon: 'money', label: 'Garantía 7 días' },
  { icon: 'mail', label: 'Soporte por email' },
] as const

export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Inmediatamente después de confirmar el pago recibirás todos los PDFs por email (en 5 minutos). Podrás descargarlos, guardarlos e imprimirlos desde cualquier dispositivo.',
  },
  {
    question: '¿Vienen listos para imprimir?',
    answer:
      'Sí. Los archivos vienen en alta resolución (300 DPI). Solo descargas, imprimes y comienzas a utilizarlos.',
  },
  {
    question: '¿Puedo usarlos en diferentes grupos o instituciones?',
    answer:
      'Sí, ilimitadamente. Tu acceso es de por vida y puedes utilizar el material en todas las jornadas que organices.',
  },
  {
    question: '¿Necesito ser psicóloga o terapeuta?',
    answer:
      'No. La Guía de Facilitación explica paso a paso cómo utilizar las dinámicas y qué rol asumir como facilitadora. El material es educativo y de concientización, y no reemplaza la intervención de profesionales de la salud.',
  },
  {
    question: '¿Qué pasa si surge un momento emocional difícil?',
    answer:
      'El Manual de Contención incluye pautas para acompañar de manera responsable, reconocer señales de alerta y saber cuándo recomendar ayuda profesional. Además, tienes soporte por email: respondo en 24 horas.',
  },
]
